import baseAPI from "@/api/base";
import { EditUser, GetUser, RegisterUser } from "@/dtos/User.dto";
import {
  DELETE_USER_URL,
  EDIT_USER_URL,
  GET_USER_STATS_URL,
  GET_USER_URL,
  RECOVER_USER_ACCOUNT_URL,
  REGISTER_USER_URL,
  TOGGLE_USER_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class User {
  static getUsers = async (getUser: GetUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_USER_URL, {
      params: getUser,
    });
    return response;
  };

  static getUserStats = async (getUser: GetUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(`${GET_USER_STATS_URL}/${getUser.id}`);
    return response;
  };

  static registerUser = async (registerUser: RegisterUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_USER_URL, {
      ...registerUser,
    });
    return response;
  };

  static editUser = async (formData: FormData): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_USER_URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  };

  static toggleUserIsActive = async (editUser: EditUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_USER_IS_ACTIVE_URL, {
      ...editUser,
    });
    return response;
  };

  static recoverUserAccount = async (editUser: EditUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(RECOVER_USER_ACCOUNT_URL, {
      ...editUser,
    });
    return response;
  };

  static deleteUser = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_USER_URL}/${id}`, {
      timeout: 120000,
    });
    return response;
  };
}

export default User;
